import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useLocation, useNavigate } from "react-router";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

const businessData = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
const deliveryData = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
const exportCustomerData = [
  { label: "CSV", value: "CSV" },
  { label: "PDF", value: "PDF" },
];

const ExportCustomer = (props) => {
  const location = useLocation();
  const [records, setRecords] = useState([]);
  const [customerRecords, setCustomerRecords] = useState(
    location.state.customerRecords
  );
  const [businessDetail, setBusinessDetail] = useState(businessData[0].value);
  const [deliveryDetail, setDeliveryDetail] = useState(deliveryData[0].value);
  const [exportCustomerDetail, setexportCustomerDetail] = useState(
    exportCustomerData[1].value
  );
  const [fileName, setFileName] = useState(location.state?.fileName?  location.state?.fileName : "Customer_Records")
  const navigate = useNavigate();

  const headers =
    businessDetail && deliveryDetail
      ? [
          { label: "CUSTOMER CODE", key: "code" },
          { label: "CUSTOMER NAME", key: "name" },
          { label: "CUSTOMER ALIAS", key: "alias" },
          { label: "TYPE OF CUSTOMER", key: "type" },
          { label: "GST NUMBER", key: "businessDetails.gst" },
          { label: "PAN NUMBER", key: "businessDetails.pan" },
          {
            label: "DATE OF DEALERSHIP",
            key: "businessDetails.dealershipDate",
          },
          { label: "CATEGORY OF CUSTOMER", key: "category" },
          { label: "CONTACT PERSON", key: "contact.person" },
          { label: "PRIMARY CONTACT NUMBER", key: "contact.number" },
          { label: "ALTERNATIVE CONTACT NUMBER", key: "contact.alternate" },
          { label: "PRIMARY EMAIL ID", key: "contact.email" },
          { label: "SECONDARY EMAIL ID", key: "contact.secondary_email" },
          { label: "OFFICE ADDRESS", key: "address" },
          { label: "OFFICE ADDRESS- COUNTRY", key: "country" },
          { label: "DELIVERY ADDRESS", key: "deliveryAddress" },
          { label: "DELIVERY ADDRESS- COUNTRY", key: "delivery_country" },
          { label: "STATUS", key: "status" },
          { label: "REMARKS", key: "remarks" },
        ]
      : businessDetail
      ? [
          { label: "CUSTOMER CODE", key: "code" },
          { label: "CUSTOMER NAME", key: "name" },
          { label: "CUSTOMER ALIAS", key: "alias" },
          { label: "TYPE OF CUSTOMER", key: "type" },
          { label: "GST NUMBER", key: "businessDetails.gst" },
          { label: "PAN NUMBER", key: "businessDetails.pan" },
          {
            label: "DATE OF DEALERSHIP",
            key: "businessDetails.dealershipDate",
          },
          { label: "CATEGORY OF CUSTOMER", key: "category" },
          { label: "CONTACT PERSON", key: "contact.person" },
          { label: "PRIMARY CONTACT NUMBER", key: "contact.number" },
          { label: "ALTERNATIVE CONTACT NUMBER", key: "contact.alternate" },
          { label: "PRIMARY EMAIL ID", key: "contact.email" },
          { label: "SECONDARY EMAIL ID", key: "contact.secondary_email" },
          { label: "OFFICE ADDRESS", key: "address" },
          { label: "OFFICE ADDRESS- COUNTRY", key: "country" },
          { label: "STATUS", key: "status" },
          { label: "REMARKS", key: "remarks" },
        ]
      : deliveryDetail
      ? [
          { label: "CUSTOMER CODE", key: "code" },
          { label: "CUSTOMER NAME", key: "name" },
          { label: "CUSTOMER ALIAS", key: "alias" },
          { label: "TYPE OF CUSTOMER", key: "type" },
          { label: "CATEGORY OF CUSTOMER", key: "category" },
          { label: "CONTACT PERSON", key: "contact.person" },
          { label: "PRIMARY CONTACT NUMBER", key: "contact.number" },
          { label: "ALTERNATIVE CONTACT NUMBER", key: "contact.alternate" },
          { label: "PRIMARY EMAIL ID", key: "contact.email" },
          { label: "SECONDARY EMAIL ID", key: "contact.secondary_email" },
          { label: "OFFICE ADDRESS", key: "address" },
          { label: "OFFICE ADDRESS- COUNTRY", key: "country" },
          { label: "DELIVERY ADDRESS", key: "deliveryAddress" },
          { label: "DELIVERY ADDRESS- COUNTRY", key: "delivery_country" },
          { label: "STATUS", key: "status" },
          { label: "REMARKS", key: "remarks" },
        ]
      : [
          { label: "CUSTOMER CODE", key: "code" },
          { label: "CUSTOMER NAME", key: "name" },
          { label: "CUSTOMER ALIAS", key: "alias" },
          { label: "TYPE OF CUSTOMER", key: "type" },
          { label: "CATEGORY OF CUSTOMER", key: "category" },
          { label: "CONTACT PERSON", key: "contact.person" },
          { label: "PRIMARY CONTACT NUMBER", key: "contact.number" },
          { label: "ALTERNATIVE CONTACT NUMBER", key: "contact.alternate" },
          { label: "PRIMARY EMAIL ID", key: "contact.email" },
          { label: "SECONDARY EMAIL ID", key: "contact.secondary_email" },
          { label: "OFFICE ADDRESS", key: "address" },
          { label: "OFFICE ADDRESS- COUNTRY", key: "country" },
          { label: "STATUS", key: "status" },
          { label: "REMARKS", key: "remarks" },
        ];

  useEffect(() => {
    if(!location?.state?.onBack){
      if(customerRecords?.length){
        fetchCustomerRecords();
      }
   } else{
      setRecords(customerRecords);
      setDeliveryDetail(location?.state?.deliveryDetail);
      setBusinessDetail(location?.state?.businessDetail);
    }
  }, [customerRecords]);
  {console.log(location.state)}

  useEffect(()=> {
    if(records?.length){
      if (!location?.state?.onBack) {
        if(exportCustomerData === "PDF")
        {
          navigate("../customer-records/export-customer/pdf", {
              state: {
                  body: location?.state?.body,
                  customerRecords: records,
                  businessDetail: businessDetail,
                  deliveryDetail: deliveryDetail,
                  rootPage: location?.state?.rootPage,
                  fileNameForPDF: fileName,
                  exportCustomerDetail: exportCustomerDetail
                },
          });
        }
        else{
          exportHandler();
        }
      }
  }
  },[records]);

  const fetchCustomerRecords = async () => {
    const formattedRecords = customerRecords?.map((customer, index) => {
      return {
        code: customer.code,
        status: `${
          customer.status == "active"
            ? "Active"
            : customer.status == "disabled"
            ? "Disabled"
            : null
        }`,
        name: customer.name,
        alias: customer.alias,
        category : customer.category == "domestic"
        ? "Domestic"
        : customer.category == "export"
        ? "Export"
        : '-',
        address: `${customer.address_line_1||"-"}, ${
          customer.address_line_2 ? `${customer.address_line_2 || "-"}, ` : ""
        }${customer.city || "-"}, ${customer.state || "-"}, ${customer.pincode || "-"}`,
        country: customer.country,
        contact: {
          person: customer.person_of_contact,
          number: customer.primary_phone_number,
          alternate: customer.secondary_phone_number,
          email: customer.primary_email,
          secondary_email: customer.secondary_email,
        },
        businessDetails: {
          pan: customer.pan_number,
          gst: customer.gst_number,
          dealershipDate:  customer.dealership_date ? moment(customer.dealership_date).format("DD-MM-YYYY") : "",
        },
        type: `${
          customer.type == "dealer"
            ? "Dealer"
            : customer.type == "direct_customer"
            ? "Direct Customer"
            : null
        }`,
        deliveryAddress: `${customer.delivery_address_line_1||"-"}, ${
          customer.delivery_address_line_2
            ? `${customer.delivery_address_line_2||"-"}, `
            : ""
        }${customer.delivery_city || "-"}, ${customer.delivery_state || "-"}, ${
          customer.delivery_pincode || "-"
        }`,
        delivery_country: customer.delivery_country,
        remarks: customer.remarks,
      };
    });
    setRecords(formattedRecords);
    setDeliveryDetail(location?.state?.deliveryDetail);
    setBusinessDetail(location?.state?.businessDetail);
    setexportCustomerDetail(location?.state?.exportCustomerDetail );
  }
  // console.log("param", customerRecords, formattedRecords);
  const handleStatusChange = (e) => {
    setBusinessDetail(e.target.value);
  };

  const deliveryStatusChange = (e) => {
    setDeliveryDetail(e.target.value);
  };

  const exportStatusChange = (e) => {
    setexportCustomerDetail(e.target.value);
  };

  const exportHandler = async () => {
    if(records?.length){
      if(exportCustomerDetail === "CSV"){

        try{
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Customer Records');

          worksheet.columns = headers.map((header)=>({
            header: header.label,
            key: header.key,
          }))

          const headRow = worksheet.getRow(1);

          headRow.eachCell((cell)=>{
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: "f3f4f6"
              }
            }
            cell.font = {
              bold: true,
            }
          })

          records?.forEach((record)=>{
            let rowData = {};

            Object.entries(record).forEach((item)=>{
              if(item[1] !== null && typeof item[1] === "object" && !Array.isArray(item[1]))
              {
                Object.entries(item[1]).forEach((obj)=>{
                  rowData[`${item[0]}.${obj[0]}`] = obj[1];
                })
              }
              else
              {
                rowData[item[0]] = item[1];
              }
            })

            const row = worksheet.addRow(rowData);
          })

          worksheet.columns.forEach((column)=>{
            let maxLength = 10;
            column.eachCell((cell)=>{
              let value = cell?.value?.toString() || "";
              maxLength = Math.max(maxLength,value?.length);
            })
            column.width = maxLength>50?50:maxLength+2;
          })

          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(new Blob([buffer]),`${fileName}.xlsx`)
        }
        catch(e)
        {
          console.log(e);
        }
                        
      } else {
          navigate("../customer-records/export-customer/pdf", {
                state: {
                    body: location?.state?.body,
                    customerRecords: records,
                    businessDetail: businessDetail,
                    deliveryDetail: deliveryDetail,
                    rootPage: location?.state?.rootPage,
                    fileNameForPDF: fileName,
                    exportCustomerDetail: exportCustomerDetail
                  },
          });
      }
    } else{
      navigate("../customer-records/preparing-export-customers", {
        state: {
          body: location?.state?.body,
          rootPage: location?.state?.rootPage,
          businessDetail: businessDetail,
          deliveryDetail: deliveryDetail,
          fileName: fileName,
          headers: headers,
          exportCustomerDetail: exportCustomerDetail
        },
      });
    }
  };

  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => navigate("../customer-records")}
          title="Export customer records"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => navigate("../customer-records")}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Select Options</h2>
                    <p>
                      Here you can select options to customize data that will be
                      downloaded
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Include Business Details</label>
                        <p>
                          Select yes if you want to include business details
                          (PAN No., GST No.) in exported data
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={businessData}
                          onChange={handleStatusChange}
                          value={businessDetail}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Include Delivery Address</label>
                        <p>
                          Select yes if you want to include delivery details in
                          exported data
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={deliveryData}
                          onChange={deliveryStatusChange}
                          value={deliveryDetail}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Data Format</label>
                        <p>Select a format to download data</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={exportCustomerData}
                          onChange={exportStatusChange}
                          value={exportCustomerDetail ? exportCustomerDetail : "PDF"}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="buttonRight" style={{ marginTop: "20px" }}>
                <Form.Item>
                  {!exportCustomerDetail || exportCustomerDetail === "PDF" ? (
                    <Button
                      onClick={() => exportHandler()}
                      className="themeBtn"
                    >
                      Preview &#38; Download Records
                    </Button>
                  ) : (
                    // <Button className="themeBtn csv">
                    //   <CSVLink
                    //     data={formattedRecords}
                    //     headers={headers}
                    //     filename={fileName+".csv"}
                    //     target="_blank"
                    //   >
                    //     Download Customer Records
                    //   </CSVLink>
                    // </Button>
                    <Button className="themeBtn csv"
                          onClick={() => exportHandler()}>
                            Download Customer Records
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
    </RightLayoutContainer>
  );
};

export default ExportCustomer;
